// PROD
/*
export const API_BASE_URL = 'https://backabc.plan-roa.org';
export const HOST_URL = 'https://abc.plan-roa.org/';
export const HOST_URL_LOGOUT = 'https://abc.plan-roa.org/authorization-code';
export const CLOSE_SESSION = 'https://plan-international.okta-emea.com/login/signout';
export const NAME = 'PRODUCTION';
*/

// TRAINING

export const API_BASE_URL = 'https://trainingbackcomms.plan-roa.org';
export const HOST_URL = 'https://trainingcomms.plan-roa.org';
export const HOST_URL_LOGOUT = 'https://trainingcomms.plan-roa.org/authorization-code';
export const CLOSE_SESSION = 'https://plan-international.oktapreview.com/oauth2/default/v1/logout';
export const NAME = 'TRAINING';


// QA ABC
/*
export const API_BASE_URL = 'https://qabackabc.plan-roa.org';
export const HOST_URL = 'https://qaabc.plan-roa.org/authorization-code/callback';
export const HOST_URL_LOGOUT = 'https://qaabc.plan-roa.org/authorization-code';
export const CLOSE_SESSION = 'https://plan-international.oktapreview.com/oauth2/default/v1/logout';
export const NAME = 'QA';
*/

// DEV
/*
export const API_BASE_URL = 'https://qabackabc.plan-roa.org';
export const HOST_URL = 'https://qaabc.plan-roa.org/authorization-code/callback';
export const HOST_URL_LOGOUT = 'https://qaabc.plan-roa.org/authorization-code';
export const CLOSE_SESSION = 'https://plan-international.oktapreview.com/oauth2/default/v1/logout';
export const NAME = 'DEV';
*/

export const AUTH_TOKEN = 'auth_token';
export const AUTH_SCOPES = 'scopes';
export const REFRESH_TOKEN = 'token_refresh';
export const USER_INFO = 'user';
export const APP_VERSION ='v4.10.4';
